import axios from "axios";
import React from 'react';
import * as constants from "../../../util/constants";
import Propertii from "../../common/Propertii";
import EditSystemAccount from "../../common/SystemAccount";

class SystemAccount extends Propertii {

    /**
     * Initialize the component.
     *
     * @param props - The properties of the component.
     */
    constructor(props) {

        super(props);

        this.state = {
            propertyLease: {},
            customer: {},
            validationList: [],
        };
    }

    /**
     * Retrieve the property lease and customer based on the property lease ID provided in the route.
     */
    componentDidMount() {

        axios.get(`${constants.REACT_APP_HOST_API_URL}/property_lease/${this.props.match.params.propertyLeaseId}`, {
            headers: this.generateRequestHeaders()
        }).then(response => {

            let propertyLease = response.data;

            axios.get(`${constants.REACT_APP_HOST_API_URL}/customer/${response.data.userId}`, {
                headers: this.generateRequestHeaders()
            }).then(response => {

                this.setState(prevState => ({
                    ...prevState,
                    propertyLease: propertyLease,
                    customer: response.data
                }));

            }).catch(error => {
                this.handleValidation(error);
            });

        }).catch(error => {
            this.handleValidation(error);
        });
    }

    /**
     * Render the component.
     *
     * @returns {*} - The edit customer system account component for admins.
     */
    render() {

        return(
            <React.Fragment>

                {this.state.customer.id &&
                <EditSystemAccount userId={this.state.customer.id}/>
                }

            </React.Fragment>
        )
    };
}

export default SystemAccount;